import { ATHOSColors } from "../../../colors/colors";

export const AIIconsDefault = `
    color: ${ATHOSColors.gray.dark};
    transition: all 0.14s;
    font-size: 1.2rem;
`;
